import React, { useEffect, useState } from "react";
import * as notify from "../../shared/notify";

import MatchItem from "./components/match-item";
import Thumbnail from "../image-stream/thumbnail";
import { lookupUUID } from "shared/attribute-uuid";
import { Select } from "../form-inputs/inputs";
import { useInput } from "../../shared/hooks/form-fields";
import { getAttributesByGroup, getAttributes } from "../attributes/lib/attribute-data";
import { buildAttributeItems } from "./lib/helpers";

import "./product-match.scss";

const correlationIdUUID = lookupUUID("correlationId");

const ProductMatch = (props) => {
    const [state, setState] = useState({
        attributeList: [],
        currentAttributes: [],
    });
    const [matchProducts, setMatchProducts] = useState([]);
    const [isDirty, setIsDirty] = useState(false);
    const [matchedProductsCount, setMatchedProductsCount] = useState(0);

    const matchSelect = useInput(props.matchTypeValue);

    async function fetchProducts() {
        const attributeList = await getAttributesByGroup("CxHMatching", { includeInvisible: true });
        const updatedAttributes = await getAttributes(props.codingWipKey);

        //CorrelationID
        const updatedCorrelationId = updatedAttributes[correlationIdUUID];

        const currentAttributes = attributeList.reduce((obj, attr) => {
            obj[attr.uuid] = {
                ...attr,
                value: props.attributes[attr.uuid],
            };

            return obj;
        }, {});

        //Set updated CorrelationID
        currentAttributes[correlationIdUUID].value = updatedCorrelationId;

        setState({
            attributeList: attributeList,
            currentAttributes: currentAttributes,
        });
    }

    useEffect(() => {
        fetchProducts();
    }, []);

    useEffect(() => {
        if (!props.matchIds || props.products.length <= 0) {
            return;
        }

        setMatchedProductsCount(
            props.products.reduce((count, product) => {
                const imagesCount = product.images.length;

                return imagesCount + count;
            }, 0)
        );

        const matches = props.products.filter((p) => props.matchIds.includes(p.productId));

        if (matches) {
            setMatchProducts(matches);
        }
    }, [props.products, props.matchIds]);

    /*useEffect(() => {
       matchSelect.setValue(props.matchTypeValue);
    }, [props.matchTypeValue]);*/

    const onCompareClick = (product) => {
        const productMatchIdList = matchProducts.map((m) => m.productId);

        if (!product || productMatchIdList.includes(product.productId)) {
            const matchProductsRemoved = matchProducts.reduce((arr, m) => {
                if (product.productId !== m.productId) {
                    arr.push(m);
                }

                return arr;
            }, []);
            setMatchProducts(matchProductsRemoved);
        } else {
            setMatchProducts([...matchProducts, product]);
        }

        setIsDirty(true);
    };

    const handleSave = () => {
        if (!isDirty) {
            return;
        }

        if (matchProducts.length === 0) {
            props.deleteMatch();

            return;
        }

        if (!matchSelect.value) {
            notify.error("A match type must be selected");

            return;
        }

        if (matchSelect.value.toString() === "1" && matchProducts.length > 1) {
            notify.error("Exact match can only have 1 matched product");

            return;
        }

        props.saveMatch(matchSelect.value, matchProducts);
    };

    const onTypeChange = (name, value) => {
        matchSelect.setValue(value);
        setIsDirty(true);
    };

    const comparedProducts = props.products.map((product, index) => {
        const productMatchIdList = matchProducts.map((m) => m.productId);
        const isSelected = matchProducts.length > 0 && product && productMatchIdList.includes(product.productId);

        return (
            <MatchItem
                key={`compare_${index}`}
                upc={props.upc}
                codingWipKey={props.codingWipKey}
                isSelected={isSelected}
                product={product}
                attributeList={state.attributeList}
                onCompareClick={onCompareClick}
            />
        );
    });
    const currentAttributeItems = buildAttributeItems("current", state.currentAttributes, state.attributeList);
    const attributeLabels = state.attributeList.map((attr) => <li key={`label_${attr.uuid}`}>{attr.name}</li>);
    const saveClass = !isDirty ? "button -primary -disabled" : "button -primary";

    return (
        <>
            <div className="product-match">
                <ul className="products-columns">
                    <li className="product">
                        <div className="top-info">
                            <button
                                className={saveClass}
                                onClick={handleSave}
                            >
                                Save
                            </button>
                            <p>
                                <a
                                    href="/files/product-match-reference.pdf"
                                    className="button -text -full"
                                    target="_blank"
                                >
                                    Reference
                                </a>
                            </p>
                        </div>
                        <ul className="attribute-list">{attributeLabels}</ul>
                    </li>

                    <li className="product -current">
                        <div className="top-info">
                            <Thumbnail
                                photoKey={props.photoKey}
                                shipmentKey={props.shipmentKey}
                                shipmentProductKey={props.shipmentProductKey}
                                size="small"
                                isInModal
                            />
                            {matchProducts.length > 0 && (
                                <Select
                                    options={props.matchOptions.filter((o) => o.isActive)}
                                    value={matchSelect.value}
                                    updateOnChange={onTypeChange}
                                />
                            )}
                            <button
                                className="link"
                                onClick={() => props.onStepChange("IMAGE_COMPARE")}
                            >
                                {matchedProductsCount} images Compare
                            </button>
                        </div>
                        <ul className="attribute-list">{currentAttributeItems}</ul>
                    </li>
                </ul>
                <ul className="products-columns -potential-matches">{comparedProducts}</ul>
            </div>
        </>
    );
};

export default ProductMatch;
